angular.module('TurneroApp').component('coPreguntasDetalle', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'preguntasService',
        'utilsService',
        'TurneroAppConstant',
        function (preguntasService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.acciones = TurneroAppConstant.Acciones;
            ctrl.tiposRespuesta = TurneroAppConstant.TiposRespuesta;
            ctrl.ordenMax = 1;
            ctrl.titulo = '';
            ctrl.lstOpciones = [];
            ctrl.lstOpcionesOriginal = [];

            ctrl.errores = {
                N_Opcion_Calificacion: false,
                Orden: false,
                Tipo_Respuesta: false,
                Opciones: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoad = function (pAccion, item) {
                    ctrl.errores = {
                        N_Opcion_Calificacion: false,
                        Orden: false,
                        Tipo_Respuesta: false,
                        Opciones: false,
                    };

                    ctrl.accion = pAccion;

                    if (ctrl.accion == ctrl.acciones.Crear) {
                        ctrl.pregunta = { Id_Opcion_Calificacion: 0 };
                        ctrl.titulo = 'Crear';
                    }
                    else if (item && item.Id_Opcion_Calificacion) {
                        ctrl.titulo = ctrl.accion == ctrl.acciones.Ver ? 'Visualizar' : 'Editar';

                        preguntasService.get({ 'id_Pregunta': item.Id_Opcion_Calificacion }).$promise.then(function (res) {
                            ctrl.pregunta = res;
                            ctrl.lstOpcionesOriginal = res.Opciones.slice();
                            ctrl.onChangeTipoRespuesta();
                        }).catch(function (req) {
                            utilsService.errores(req);
                            ctrl.ctrlPadre.grillaReload();
                        });
                    }

                    //lleno el combo de tipo de respuesta
                    preguntasService.Get_Tipos_Respuesta().$promise.then(function (res) {
                        ctrl.lstTiposRespuesta = res.Data;
                    }).catch(function (req) {
                        utilsService.errores(req);
                        ctrl.ctrlPadre.grillaReload();
                    });
                }
            }

            ctrl.onChangeTipoRespuesta = function () {
                if (ctrl.pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.Opciones) {
                    //lleno el combo de opciones
                    preguntasService.Get_Opciones_Respuesta().$promise.then(function (res) {
                        ctrl.lstOpciones = res.Data;
                    }).catch(function (req) {
                        utilsService.errores(req);
                        ctrl.ctrlPadre.grillaReload();
                    });
                }
            }

            ctrl.onNuevaOpcion = function (pText) {
                return { id: -1, text: pText };
            }

            ctrl.guardar = function () {
                ctrl.pregunta.Orden = parseInt(ctrl.pregunta.Orden);

                ctrl.errores.Orden = ctrl.pregunta.Orden ? ctrl.pregunta.Orden < 1 : true;
                ctrl.errores.N_Opcion_Calificacion = !(ctrl.pregunta.N_Opcion_Calificacion);
                ctrl.errores.Tipo_Respuesta = !(ctrl.pregunta.Id_Tipo_Respuesta);
                ctrl.errores.Opciones = ctrl.pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.Opciones ? ctrl.pregunta.Opciones.length < 2 : false;

                if (ctrl.errores.N_Opcion_Calificacion ||
                    (ctrl.accion == ctrl.acciones.Editar && ctrl.errores.Orden) ||
                    ctrl.errores.Tipo_Respuesta ||
                    ctrl.errores.Opciones) {
                    return
                };

                if (ctrl.accion == ctrl.acciones.Editar) {
                    //valido las opciones que fueron eliminadas
                    ctrl.pregunta.Lst_Opciones_Eliminadas = ctrl.lstOpcionesOriginal.filter((item) => {
                        return ctrl.pregunta.Opciones.findIndex((x) => { return x.id == item.id }) == -1;
                    })

                    //valido las opciones que fueron incluidas
                    ctrl.pregunta.Opciones = ctrl.pregunta.Opciones.filter((item) => {
                        return ctrl.lstOpcionesOriginal.findIndex((x) => { return x.id == item.id }) == -1;
                    })

                    preguntasService.update(ctrl.pregunta).$promise.then(function (res) {
                        ctrl.ctrlPadre.grillaReload();
                        sweetAlert("Modificar Pregunta", "La Pregunta se modifico correctamente", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                }
                else if (ctrl.accion == ctrl.acciones.Crear) {
                    preguntasService.save(ctrl.pregunta).$promise.then(function (res) {
                        ctrl.ctrlPadre.grillaReload();
                        sweetAlert("Crear Pregunta", "La Pregunta se registró correctamente", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                }
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./preguntasDetalle.html')
});


// WEBPACK FOOTER //
// ./app/components/preguntas/preguntasDetalleComponent.js